import React from 'react';
import I18n from 'i18n-js';

import { RCRadioGroup } from '@reverbdotcom/cadence/components';

interface Props {
  willPayImmediately: boolean;
  setWillPayImmediately: (any) => void;
  defaultToImmediatePayment?: boolean;
  inExperiment?: boolean;
}

export function PayImmediatelyRadioGroup({ willPayImmediately, setWillPayImmediately, defaultToImmediatePayment = false, inExperiment = false }: Props) {
  const payImmediatelyOption = (
    <RCRadioGroup.Option
      label={inExperiment ? I18n.t('commons.offers.immediatePayment.options.experiment.immediately.label') : I18n.t('commons.offers.immediatePayment.options.immediately.label')}
      sublabel={inExperiment ? I18n.t('commons.offers.immediatePayment.options.experiment.immediately.sublabel') : I18n.t('commons.offers.immediatePayment.options.immediately.sublabel')}
      key="true"
      value="true"
    />
  );
  const standardOption = (
    <RCRadioGroup.Option
      label={inExperiment ? I18n.t('commons.offers.immediatePayment.options.experiment.standard.label') : I18n.t('commons.offers.immediatePayment.options.standard.label')}
      sublabel={inExperiment ? I18n.t('commons.offers.immediatePayment.options.experiment.standard.sublabel') : undefined}
      key="false"
      value="false"
    />
  );

  let options;
  if (defaultToImmediatePayment) {
    options = [payImmediatelyOption, standardOption];
  } else {
    options = [standardOption, payImmediatelyOption];
  }

  return (
    <RCRadioGroup
      id="payImmediately"
      name="payImmediately"
      label={I18n.t('commons.offers.immediatePayment.heading')}
      value={willPayImmediately.toString()}
      onChange={() => { setWillPayImmediately(!willPayImmediately); }}
    >
      {options}
    </RCRadioGroup>
  );
}

export default PayImmediatelyRadioGroup;
